import { ReactNode } from 'react';
import { Theme, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';



interface ILayoutBaseDePaginaProps {
  children: React.ReactNode
  barraDeFerramentas?: ReactNode;
}

export const LayoutBaseDePaginaColaborador: React.FC<ILayoutBaseDePaginaProps> = ({ children, barraDeFerramentas  }) => {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const theme = useTheme();


  return (
    <Box  height="100%" display="flex" flexDirection="column" >
      <Box margin={0.5} display="flex" alignItems="center" height={theme.spacing(smDown ? 1 : mdDown ? 8 : 0)}>
        {/* Celular: sem botão de menu — a navegação é a barra de baixo (AppMobile.tsx). */}
      </Box>

      {barraDeFerramentas && (
        <Box>
          {barraDeFerramentas}
        </Box>
      )}

      <Box padding={1}  overflow="auto">
        {children}
      </Box>
    </Box>
  );
};